import React from 'react'
import '../Styles/JuniorCampPage2.scss';
import speakerImage1 from "../Images/140308_Stump,_Levi_U3.png";
import speakerImage2 from "../Images/136353_Palchevskiy,_Jonathan_U3_1.png";
import speakerImage3 from "../Images/140311_Stump,_Grant_U3.png"

function JuniorCampPage2() {
   return(
      <div className="juniorCampPage2Content">
         <div className="juniorCampPage2Container">
            <div className="juniorCampPage2Title">
                  2023 Junior Camp Speakers
            </div>
            <div className="juniorCampPage2SpeakerPictures">
               <div className="juniorPictureAndText1">
                  <div className='speakerPicture1'>
                     <img className="juniorPic1" src={speakerImage1} alt="SpeakerImage1"></img>
                  </div>
                  <div className="speakerName1">
                     Week 1 <br></br>
                     Levi Stump
                  </div>
               </div>

               <div className="juniorLineContainer">
                  <div className="juniornvl"></div>
               </div>
               
               <div className="juniorPictureAndText2">
                  <div className='speakerPicture2'>
                     < img className="juniorPic2" src={speakerImage2} alt="SpeakerImage2"></img>
                  </div>
                  <div className="speakerName2">
                     Week 2 <br></br>
                     Jonathan Palchevskiy
                  </div>
               </div>

               <div className="juniorLineContainer">
                  <div className="juniornvl"></div>
               </div>

               <div className="juniorPictureAndText3">
                  <div className='speakerPicture2'>
                     < img className="juniorPic2" src={speakerImage3} alt="SpeakerImage2"></img>
                  </div>
                  <div className="speakerName2">
                     Week 2 <br></br>
                     Grant Stump
                  </div>
               </div>

            </div>
         </div>
      </div>
   )
}
export default JuniorCampPage2;